"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pushRelateds = pushRelateds;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _lodash = _interopRequireDefault(require("lodash"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _env = require("../../utils/env");

/**
 * Push related items into their respective place in the redux store
 * @param  {Function} dispatch   Redux store action dispatcher
 * @param  {Object} relatedItems
 * @param  {Object} relatedData
 * @param  {string} uuid
 * @return {null}
 */
function pushRelateds(dispatch, relatedItems, relatedData, uuid) {
  for (var name in relatedItems) {
    var related = relatedItems[name];

    if (!related || !related.model) {
      continue;
    }

    var relatedModel = related.model;

    if ((0, _isArray.default)(relatedModel)) {
      // We use arrays to indicate 1:n relationships
      //  So wee need to strip these here!
      relatedModel = relatedModel[0];
    }

    if (!_lodash.default.get(relatedModel, 'actionCreators.pushItems')) {
      continue;
    }

    if (!relatedData[relatedModel.modelName]) {
      if (_env.__DEV__) {
        console.warn("No data found for related record(s) with key \"".concat(name, "\"!"));
      }

      continue;
    }

    var items = [];

    for (var id in relatedData[relatedModel.modelName][_entityNormalizer.ITEMS]) {
      items.push(relatedData[relatedModel.modelName][_entityNormalizer.ITEMS][id][_entityNormalizer.DATA]);
    }

    if (items.length > 0) {
      dispatch(relatedModel.actionCreators.pushItems({
        items: items,
        uuid: uuid,
        source: _entityNormalizer.SOURCE_RELATED
      }));
    }
  }
}